import { Injectable } from '@angular/core';
import { ExchangeApiService } from '../../shared/services/exchange-api.service';
import { Observable } from 'rxjs';
import { Question } from '../models/question.model';
import { Survey } from '../models/survey.model';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { QuestionGroup } from '../models/question-group.model';

@Injectable()
export class SurveyService {

  path = 'surveys';

  constructor(
      private apiService: ExchangeApiService,
  ) {
  }

  get(id: string, lang: string = ''): Observable<Survey> {
    return this.apiService.get(`${this.path}/${id}`, new HttpParams(), lang)
        .pipe(map(data => data));
  }

  getAll(topic: string = null, isEnabled: boolean = true): Observable<Survey[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('isEnabled', String(isEnabled));

    if (topic) {
      httpParams = httpParams.set('topic', topic);
    }

    return this.apiService.getSave(this.path, [httpParams]);
  }

  getQuestionGroups(id: string, lang: string = ''): Observable<QuestionGroup[]> {
    return this.apiService.get(`${this.path}/${id}/question_groups`, new HttpParams(), lang)
        .pipe(map(data => data));
  }

  delete(survey) {
    return this.apiService.delete(`${this.path}/${survey.id}`)
        .pipe(map(data => data));
  }

  save(survey, lang: string = ''): Observable<Survey> {
    if (survey.id) {
      return this.apiService.put(`${this.path}/${survey.id}`, survey, lang)
          .pipe(map(data => data));
    } else {
      return this.apiService.post(`${this.path}`, survey, lang)
          .pipe(map(data => data));
    }
  }

  getQuestions(id: number, lang: string = ''): Observable<Question[]> {
    return this.apiService.get(`${this.path}/${id}/questions`, new HttpParams(), lang)
      .pipe(map(data => data));
  }
}
